import React from 'react'
import Hero from '../Hero'
import Button from '../Button'
import { Header1 } from '../../styles/Components'
import { gsColors } from '../../styles/Variables'
import HeroImage from '../../../public/about-us/hero.jpg'
import { HeroEyebrow, AboutHeroOverride } from './styles'

const AboutHeroContent = () => (
  <>
    <HeroEyebrow>ON-DEMAND BEAUTY SERVICES</HeroEyebrow>
    <div className="hero-headline-group">
      <Header1
        as="div"
        className="hero-headline"
        color={gsColors.salmon}
        margin="0"
        align="center"
        style={{ textTransform: 'uppercase' }}
      >
        BEAUTY-OBSESSED
      </Header1>
      <div className="hero-subheadline">(JUST LIKE YOU)</div>
    </div>
    <Button
      large
      color={gsColors.white}
      path="book"
      padding="14px 80px"
      className="about-hero-cta"
      style={{ color: gsColors.cobalt }}
    >
      Book Glam
    </Button>
  </>
)

const AboutHero = () => (
  <AboutHeroOverride>
    <Hero
      image={HeroImage}
      imageAlt="Glamsquad client with glossy gray curls and bold red lipstick blowing bubbles, beauty-obsessed just like you"
      content={<AboutHeroContent />}
      header="Beauty-obsessed (just like you)"
      hideCTA
      className="about-us-hero"
    />
  </AboutHeroOverride>
)

export default AboutHero
